module.exports = "<textarea #editor class=\"{{inputClass}}\" [ngClass]=\"{'isValid': isValid}\" [required]=\"isRequired\" ></textarea>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/editor/editor.component.html
// module id = 2325
// module chunks = 66